import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { callGetUserManagement } from '../../api/settings/service';
import { useTranslation } from "react-i18next";

const UserInput = ({ value = '', onSelect, initialData = null }) => {
	const dispatch = useDispatch();
	const [inputValue, setInputValue] = useState(value);
	const [suggestions, setSuggestions] = useState([]);
	const [showSuggestions, setShowSuggestions] = useState(false);
	const containerRef = useRef(null);
	const debounceTimeout = useRef(null);
	const { t } = useTranslation();

	useEffect(() => {
		if (initialData) {
			setInputValue(`${initialData}`);
		}
	}, [initialData]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (containerRef.current && !containerRef.current.contains(event.target)) {
				setShowSuggestions(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const fetchSuggestions = async (text) => {
		const response = await dispatch(callGetUserManagement({ keyword: text, page: 1, maxResult: 50 }));
		if (response?.payload?.responseCode === "00000") {
			setSuggestions(response.payload.data.result || []);
			setShowSuggestions(true);
		}
	};

	const handleChange = (e) => {
		const text = e.target.value;
		setInputValue(text);
		clearTimeout(debounceTimeout.current);
		if (text.trim() === "") {
			setSuggestions([]);
			setShowSuggestions(false);
			return;
		}
		debounceTimeout.current = setTimeout(() => {
			fetchSuggestions(text);
		}, 500);
	};

	const handleSelect = (agent) => {
		setInputValue(`${agent.userId} - ${agent.firstName} ${agent.lastName} - ${agent.rolesCode}`);
		setShowSuggestions(false);
		onSelect(agent);
	};

	return (
		<div ref={containerRef} style={{ position: 'relative' }}>
			<input
				type="text"
				className="form-control-uld"
				placeholder={t('callcenter.user.searchByKey') + "..."}
				value={inputValue}
				onChange={handleChange}
				autoComplete="off"
			/>
			{showSuggestions && suggestions.length > 0 && (
				<ul style={{
					position: 'absolute',
					top: '100%',
					left: 0,
					right: 0,
					zIndex: 999,
					backgroundColor: '#fff',
					border: '1px solid #ccc',
					maxHeight: '200px',
					overflowY: 'auto',
					listStyle: 'none',
					margin: 0,
					padding: 0
				}}>
					{suggestions.map((agent, index) => (
						<li key={index} style={{ padding: '8px', cursor: 'pointer' }}
							onClick={() => handleSelect(agent)}>
							{agent.userId} - {agent.firstName} {agent.lastName} - {agent.rolesCode}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default UserInput;
